import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, ChangePassword, UnauthorizedLayoutContent} from 'components';
import {LogoutType} from 'enums';
import {UnauthorizedLayout} from 'layouts';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.USER.PASSWORD_EXPIRED;
const COMMON_T_KEYS = TRANSLATION_KEYS.COMMON;

export const PasswordExpired: React.FC = () => {
    const {t} = useTranslation();

    const localUser = useMemo(() => userAuthUtils.getLocalUser(), []);

    const handleLogout = useCallback(() => {
        userAuthUtils.logout(LogoutType.Manually);
    }, []);

    const handleSuccess = useCallback(() => {
        setTimeout(() => {
            window.location.reload();
        }, 1000); // just some time to let user see a success message that password changed
    }, []);

    return (
        <UnauthorizedLayout>
            <UnauthorizedLayoutContent title='' highlight={false}>
                <div className='tw-text-center tw-mb-4'>
                    <div className='tw-ts-h3-bold tw-color-black tw-mb-4'>{`${t(COMMON_T_KEYS.ALL.HELLO)}, ${localUser.firstName}`}</div>
                    <div>{t(T_KEYS.PASSWORD_EXPIRED)}</div>
                    <div>{t(T_KEYS.CHANGE_PASSWORD)}</div>
                </div>
                <ChangePassword
                    cancelButton={
                        <Button className='tw-mx-1 tw-mb-2' onClick={handleLogout}>
                            {t(TRANSLATION_KEYS.COMMON.BUTTONS.LOGOUT)}
                        </Button>
                    }
                    onSuccess={handleSuccess}
                />
            </UnauthorizedLayoutContent>
        </UnauthorizedLayout>
    );
};